import { useCallback, useState } from "react";
import { TriggeredHook } from "sonobello.utilities.react";

import { Error } from "../../../../Utils/Errors";
import { useApi } from "../../../../Utils/useApi";
import { putContactResultPath } from "../../../Constants/ApiRequestPaths";
import CreateOrUpdateContactResultResponse from "../Types/CreateOrUpdateContactResultResponse";
import UpdateContactResultRequest, { UpdateContactResultRequestPayload } from "../Types/UpdateContactResultRequest";

/** A hook for updating contact results. */
const UsePutContactResult: TriggeredHook<CreateOrUpdateContactResultResponse, UpdateContactResultRequest> = () => {
  const [requestPayload, setRequestPayload] = useState<UpdateContactResultRequest | null>(null);

  const { response, error, isLoading } = useApi<CreateOrUpdateContactResultResponse, UpdateContactResultRequestPayload>(
    {
      method: "put",
      url: putContactResultPath(requestPayload?.contactId ?? "", requestPayload?.payload.id ?? ""),
      data: requestPayload?.payload,
      valid: !!requestPayload,
      error: Error.PutLeadResult
    }
  );

  const execute = useCallback((request: UpdateContactResultRequest) => {
    setRequestPayload(request);
  }, []);

  return {
    execute,
    result: response ? response : null,
    error: error ? true : false,
    isLoading: isLoading
  };
};

export default UsePutContactResult;
